import { createSelector } from 'reselect';

export const makeSelectUsageState = () => (state) => state.get('usage');

export const makeSelectFetchingBilling = () => createSelector(
  makeSelectUsageState(),
  (substate) => substate.get('fetching')
);

export const makeSelectFetchingUsage = () => createSelector(
  makeSelectUsageState(),
  (substate) => substate.get('fetchingUsage')
);

export const makeSelectFetchingSubUsage = () => createSelector(
  makeSelectUsageState(),
  (substate) => substate.get('fetchingSubUsage')
);


export const makeSelectEntities = () => createSelector(
  makeSelectUsageState(),
  (substate) => substate.get('entities')
);

export const makeSelectAllUsages = () => createSelector(
  makeSelectUsageState(),
  (substate) => substate.get('allUsagesData')
);

export const makeSelectBillingPeriods = () => createSelector(
  makeSelectUsageState(),
  (substate) => substate.get('billingPeriods')
);

export const makeSelectSubUsage = () => createSelector(
  makeSelectUsageState(),
  (substate) => substate.get('subscriptionUsage')
);
